import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMacbook: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="macbook, laptop, computer"><path d="M22.25 17C22.6642 17 23 17.3358 23 17.75V19.25C23 20.2165 22.2165 21 21.25 21H2.75C1.7835 21 1 20.2165 1 19.25V17.75C1 17.3358 1.33579 17 1.75 17H22.25Z" fill="currentColor"/><path d="M19.25 3C20.2165 3 21 3.7835 21 4.75V15.5H3V4.75C3 3.7835 3.7835 3 4.75 3H19.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMacbook;
